var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 43.3 41",
    enableBackground: "new 0 0 43.3 41",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BB9158",
    d: "M21.7,18.3c-3.2,0-5.5-1.4-5.7-1.5c-0.5-0.3-0.6-0.9-0.3-1.4c0.3-0.5,0.9-0.6,1.4-0.3c0.2,0.1,4.5,2.6,9,0 c0.5-0.3,1.1-0.1,1.4,0.4s0.1,1.1-0.4,1.4C25.2,17.9,23.4,18.3,21.7,18.3z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BB9158",
    d: "M16.9,31c-0.6,0-1-0.4-1-0.9c0,0-0.1-3.8-2.8-6.5c-2.9-2.5-4.6-6.2-4.6-10.1c0-7.3,6-13.3,13.3-13.3 C29,0.2,35,6.2,35,13.5c0,3.7-1.6,7.3-4.3,9.8c-3.6,3.3-3.4,6.6-3.4,6.8c0,0.5-0.4,1-0.9,1.1c-0.5,0-1-0.4-1.1-0.9 c0-0.2-0.2-4.4,4.1-8.4c2.3-2.1,3.6-5.2,3.6-8.3c0-6.2-5.1-11.3-11.3-11.3S10.4,7.3,10.4,13.5c0,3.3,1.5,6.5,4,8.6 c3.4,3.4,3.5,7.7,3.5,7.9C17.9,30.6,17.4,31,16.9,31C16.9,31,16.9,31,16.9,31z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BB9158",
    d: "M21.4,28c-0.6,0-1-0.4-1-1v-9c0-0.6,0.4-1,1-1s1,0.4,1,1v9C22.4,27.6,22,28,21.4,28z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BB9158",
    d: "M23.4,41h-3.7c-2,0-3.7-1.5-3.8-3.5c0-0.1,0-0.1,0-3.6c0-0.6,0.4-1,1-1c0,0,0,0,0,0c0.6,0,1,0.4,1,1 c0,0.7,0,3.3,0,3.6c0.1,0.9,0.9,1.6,1.8,1.6h3.7c1,0,1.8-0.8,1.8-1.8v-6h-8.3c-0.6,0-1-0.4-1-1s0.4-1,1-1h9.3c0.6,0,1,0.4,1,1v7 C27.3,39.3,25.6,41,23.4,41z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BB9158",
    d: "M25.4,36h-5c-0.6,0-1-0.4-1-1s0.4-1,1-1h5c0.6,0,1,0.4,1,1S26,36,25.4,36z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BB9158",
    d: "M37.8,15c-0.6,0-1-0.6-1-1.1c0-0.6,0.4-0.9,1-0.9l4.5,0.1c0,0,0,0,0,0c0.6,0,1,0.3,1,0.9 c0,0.6-0.4,1.1-1,1.1L37.8,15C37.8,15,37.8,15,37.8,15z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BB9158",
    d: "M37,6.9c-0.4,0-0.7-0.2-0.9-0.6c-0.2-0.5,0-1.1,0.5-1.3l4.1-1.8c0.5-0.2,1.1,0,1.3,0.5 c0.2,0.5,0,1.1-0.5,1.3l-4.1,1.8C37.3,6.9,37.1,6.9,37,6.9z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BB9158",
    d: "M5.5,15C5.5,15,5.5,15,5.5,15L1,14.8c-0.6,0-1-0.4-1-0.9C0,13.4,0.4,13,1,13c0,0,0,0,0,0l4.5-0.1 c0.6,0,1,0.5,1,1.1C6.5,14.5,6,15,5.5,15z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BB9158",
    d: "M6.3,6.9c-0.1,0-0.3,0-0.4-0.1L1.8,5C1.3,4.8,1.1,4.2,1.3,3.7C1.5,3.2,2.1,3,2.6,3.2L6.7,5 c0.5,0.2,0.7,0.8,0.5,1.3C7,6.7,6.6,6.9,6.3,6.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.ea1dda9841ab6d5af7ffc4a337535714.svg";
export { ForwardRef as ReactComponent };